import arkReducers from './Ark'
import devicesReducers from './devices'
import eventspaceReducers from './eventspace'
import inrunReducers from './inrun'
import largeVisionReducers from './LargeVision'
import liftAndLearnReducers from './liftandlearn'
import mediaReducers from './media'
import minivisionReducers from './minivision'
import notesReducers from './notes'
import playlistsReducers from './playlists'
import wfhReducers from './wfh'
import wowReducers from './wow'
import JLPReducers from './JLP';
import EventSpace2Reducers from './EventSpace2'

export default [
    ...arkReducers,
    ...devicesReducers,
    ...eventspaceReducers,
    ...inrunReducers,
    ...largeVisionReducers,
    ...liftAndLearnReducers,
    ...mediaReducers,
    ...minivisionReducers,
    ...notesReducers,
    ...playlistsReducers,
    ...wfhReducers,
    ...wowReducers,
    ...JLPReducers,
    ...EventSpace2Reducers
]
